import { useState, useEffect } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { Box, Button, Divider, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import headerIcon from "../../images/headerIcon.png";
import maintenanceIcon from "../../images/maintenanceIcon.png";

const Maintenance = () => {
	const history = useHistory();
	const [showPage, setShowPage] = useState(false);

	const handleReload = () => {
		window.location.href = "/";
	};

	useEffect(() => {
		const isMaintenance = sessionStorage.getItem("isMaintenance");
		if (isMaintenance) {
			setShowPage(true);
		} else {
			history.goBack();
		}
	}, []);

	if (!showPage) return null;
	return (
		<Box>
			<CssBaseline />
			<Box sx={{ padding: "5px" }}>
				<img className="headerIcon" src={headerIcon} style={{ cursor: "pointer" }} onClick={handleReload} />
			</Box>
			<Divider sx={{ borderWidth: "4px", borderColor: ({ palette }) => palette.primary.main }} />
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					height: "calc(100vh - 166px)",
				}}
			>
				<img src={maintenanceIcon} style={{ width: 200, height: 200 }} />
				<Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
					EHPDCL Portal is under maintenance.
				</Typography>
				<Typography variant="h6" gutterBottom>
					Portal service will resume shortly.
				</Typography>
				<Button variant="contained" onClick={handleReload}>
					Reload
				</Button>
			</Box>
		</Box>
	);
};

export default Maintenance;
